import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home/Home";
import Photography from "./components/Photography/Photography";
import Test from "./components/Photography/Test";
import Test2 from "./components/Photography/Test2";
import SocialMedia from "./components/SocialMedia/SocialMedia";
import ThreeD from "./components/ThreeD/ThreeD";
import Brand from "./components/Brand/Brand";
import Collaborate from "./components/Collaborate/Collaborate";
import FAQ from "./components/FAQ/FAQ";
import WorkPage from "./components/WorkPage/WorkPage";
import PhotographyShowcase from "./components/Photography/PhotographyShowcase";
import BrochureCreation from "./components/BrochureCreation/BrochureCreation";
 
//Trans globe
// import Calculator from "./components/Calculator/calculator";
// import Header from "./components/tgheader/Header";
// import Destinations from "./components/Calculator/Destinations";
// import Universities from "./components/Calculator/Universities";
// import Checkout from "./components/Calculator/checkout";
// import StudyDestination from "./components/Calculator/StudyDestination";

// import Ielts from "./components/Tests/Ielts";
// import Toefl from "./components/Tests/Toefl";
// import Pte from "./components/Tests/Pte";
// import Gre from "./components/Tests/Gre";
// import Gmat from "./components/Tests/Gmat";
// import Sat from "./components/Tests/Sat";
// import German from "./components/Tests/German";


function App() {
  return (
    <div> 
      <Router>
        <Routes>
          {/* open studio */}
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Photography" element={<Photography />} />
          <Route path="/SocialMedia" element={<SocialMedia />} />
          <Route path="/3D" element={<ThreeD />} />
          <Route path="/Brand" element={<Brand />} />
          <Route path="/Collaborate" element={<Collaborate />} />
          <Route path="/FAQ" element={<FAQ />} />
          <Route path="/WorkPage" element={<WorkPage />} />
          <Route path="/PhotographyShowcase" element={<PhotographyShowcase />} />
          <Route path="/BrochureCreation" element={<BrochureCreation />} />


          {/* Trans globe */}
          {/* <Route path="/Calculator" element={<Calculator />} />
          <Route path="/Header" element={<Header />} />
          <Route path="/Destinations" element={<Destinations />} />
          <Route path="/Universities" element={<Universities />} />
          <Route path="/Checkout" element={<Checkout />} />
          <Route path="/study-destination/:link" element={<StudyDestination />} /> */}

          {/* <Route path="/Ielts" element={<Ielts />} /> */}
           {/* <Route path="/Toefl" element={<Toefl />} /> */}
         {/* <Route path="/Pte" element={<Pte />} /> */}
          {/* <Route path="/Gre" element={<Gre />} /> */}
          {/* <Route path="/Gmat" element={<Gmat />} /> */}
          {/* <Route path="/Sat" element={<Sat />} /> */}
           {/* <Route path="/German" element={<German />} /> */}



          <Route path="/Test" element={<Test />} />
          <Route path="/Test2" element={<Test2 />} />

          {/* <Route path="*" element={<Error />} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
